import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);

  useEffect(() => {
    const authenticate = async () => {
      try {
        const body = {
          username: "jzurita",
          password: "Master75"
        };
        const response = await axios.post(
          `https://ghost-main-static-b7ec98c880a54ad5a4782393902a32a2.ghostapi.app:29003/api/v1/authenticate`,
          body,
          { headers: { 'Content-Type': 'application/json' } }
        );

        setToken(response.data.secret);
      } catch (err) {
      console.error('Error authenticating:', err);
      if (err.response) {
        console.error('Status:', err.response.status);
        console.error('Data:', err.response.data);  // Esto es clave
      }
    }
    
    };

    authenticate();
  }, []);

  return (
    <AuthContext.Provider value={{ token }}>
      {children}
    </AuthContext.Provider>
  );
};
